import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../../Styles/DashboardStyle.module.css';
import DashboardTitle from "../DashboardTitle";
import DashBoardLeftProfileMenu from "../DashBoardLeftProfileMenu";
import { getUserBussinessListFormData,getOffersUpdateFormData, createOffersForBusniess } from "../../../services/routes.services";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { AiOutlinePlusCircle } from "react-icons/ai";
import Button from '../../Styles/Button.module.css';
import { useSelector } from 'react-redux';

const MyOfferCreate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const offerDetails = location.state?.offerDetails || {};

    const [selectedCompany, setSelectedCompany] = useState(offerDetails.company || "");
    const [packageName, setPackageName] = useState(offerDetails.package || "");
    const [couponCode, setCouponCode] = useState(offerDetails.couponCode || "");
    const [contactNumber, setContactNumber] = useState(offerDetails.businessOfferContactNumber || "");
    const [offerDescription, setOfferDescription] = useState(offerDetails.offerDescription || "");
    const [getAllData, setGetAllData] = useState(null);
    const [errors, setErrors] = useState({});
    const { token } = useSelector((state) => state.auth);

    useEffect(() => {
        getUserBussinessListFormData(token)
            .then((res) => {
                setGetAllData(res.data.business);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const handleAddCompany = () => {
        navigate('/business-directory-create');
    };

    const validateForm = () => {
        const newErrors = {};
        if (!selectedCompany) newErrors.selectedCompany = "Company is required";
        if (!packageName) newErrors.packageName = "Package / Discount is required";
        if (!couponCode) newErrors.couponCode = "Coupon Code is required";
        if (!contactNumber) newErrors.contactNumber = "Contact Number is required";
        if (!offerDescription) newErrors.offerDescription = "Offer Description is required";
        return newErrors;
    };

    const handleOfferAddSubmit = async (event) => {
        event.preventDefault();
        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            return;
        }

        try {
            const formData = new FormData();
            formData.append('company', selectedCompany);
            formData.append('package', packageName);
            formData.append('couponCode', couponCode);
            formData.append('businessOfferContactNumber', contactNumber);
            formData.append('offerDescription', offerDescription);
            
            if(offerDetails &&((typeof offerDetails === "object" && !Array.isArray(offerDetails) && Object.keys(offerDetails).length > 0) || (Array.isArray(offerDetails) && offerDetails.length > 0))){
            if( offerDetails._id!=='undefined'){
           
                getOffersUpdateFormData(offerDetails._id,formData,token)
            .then(response => {
                if(response.status===200){
                  navigate("/myoffer")
                }
                console.log("post update successfully", response);
            })
            .catch(error => {
                console.error("Error creating business", error);
            });
        }
            }
            else{
            let response = await createOffersForBusniess(formData,token);

            if (response.success === 200 || response.status === 201 || response.success === true) {
                toast.success(`Offer Added successfully!`, {
                    position: "top-right",
                    autoClose: 2000,
                    type: 'success'
                });
                navigate(-1); // Navigate back
            } else {
                toast.error(`Job offer Not Added!`, {
                    position: "top-right",
                    autoClose: 2000,
                    type: 'error'
                });
            }
        }
        } catch (error) {
            console.error(`Error adding job offer:`, error);
            toast.error(`An error occurred while adding the offer.`, {
                position: "top-right",
                autoClose: 2000,
                type: 'error'
            });
        }
    };

    return (
        <div>
            <DashBoardLeftProfileMenu />
            <div className={'containerStyla ' + Style.Dashboardscreen + " " + Style.BussinesList}>
                <Container>
                    <DashboardTitle title="Offer Posting" membertype="Non Member" />
                    <Row className={Style.space}>
                        <Col>
                            <div className={Style.newFormStyle}>
                                <h3 className={Style.dashboardSubTitle}>ADD Offer</h3>
                                <form onSubmit={handleOfferAddSubmit} id="myform" method="post" noValidate>
                                    <div className={Style.formContainer}>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>Company</label>
                                                {console.log(selectedCompany)}
                                                <select className={Style.inputStyle} value={selectedCompany} onChange={(e) => setSelectedCompany(e.target.value)}>
                                                    <option>Select Business Directory</option>
                                                    {getAllData && getAllData.map((BinessName) => (
                                                        <option key={BinessName._id} value={BinessName._id}>{BinessName.name}</option>
                                                    ))}
                                                </select>
                                                {errors.selectedCompany && <span className={Style.error}>{errors.selectedCompany}</span>}
                                            </div>
                                            <div className={Style.addCol}>
                                                <button className={Button.greenBtn + ' ' + Button.greenBtn} onClick={handleAddCompany}><AiOutlinePlusCircle /> ADD COMPANY</button>
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol}>
                                                <label>Package / Discount</label>
                                                <input type='text' className={Style.inputStyle} value={packageName} onChange={(e) => setPackageName(e.target.value)} />
                                                {errors.packageName && <span className={Style.error}>{errors.packageName}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Business Offer Contact No.</label>
                                                <input className={Style.inputStyle} type='text' value={contactNumber} onChange={(e) => setContactNumber(e.target.value)} />
                                                {errors.contactNumber && <span className={Style.error}>{errors.contactNumber}</span>}
                                            </div>
                                            <div className={Style.fromCol}>
                                                <label>Coupon Code</label>
                                                <input type='text' className={Style.inputStyle} value={couponCode} onChange={(e) => setCouponCode(e.target.value)} />
                                                {errors.couponCode && <span className={Style.error}>{errors.couponCode}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol2}>
                                                <label>Offer Description</label>
                                                <textarea type='text' className={Style.inputStyle} value={offerDescription} onChange={(e) => setOfferDescription(e.target.value)}></textarea>
                                                {errors.offerDescription && <span className={Style.error}>{errors.offerDescription}</span>}
                                            </div>
                                        </div>
                                        <div className={Style.fromRow}>
                                            <div className={Style.fromCol2 + ' ' + Style.fromBtn}>
                                                <button type="submit" className={Style.subBtn}>Submit</button>
                                                <button type="button" className={Style.clearBtn} onClick={() => navigate(-1)}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Col>
                    </Row>
                    <ToastContainer />
                </Container>
            </div>
        </div>
    );
};

export default MyOfferCreate;
